// extracted by mini-css-extract-plugin
module.exports = {"Container":"_3ivBvX8G","CandidateRegistration":"_3Y3OsZIS","Title":"_1nESm8ai","errorMessage":"_149wt8Iu"};
    if(module.hot) {
      // 1754514925113
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  